import { createSelector } from 'reselect'

const otherProjectSelector = state => state.manage.nvbug.nvbugsDialog.otherProject
const otherProjectListSelector = state => state.manage.nvbug.nvbugsDialog.otherProjectList
const nvbugsIdSelector = state => state.manage.nvbug.nvbugsDialog.nvbugId
const synopsisSelector = state => state.manage.nvbug.nvbugsDialog.synopsis
const pageSelector = state => state.manage.nvbug.nvbugsDialog.page
const recProjectListSelector = state => state.manage.nvbug.nvbugsDialog.recProjectList
const recProjectListLoadingSelector = state => state.manage.nvbug.nvbugsDialog.recProjectListLoading
const optionSelectedSelector = state => state.manage.nvbug.nvbugsDialog.optionSelected

const selectedProjectSelector = createSelector(
  optionSelectedSelector,
  otherProjectSelector,
  (option, otherProject) => {
    if (option && option != 'other') {
      return option
    }
    else if (option == 'other' && otherProject) {
      return otherProject.value
    } else {
      return null
    }
  }
)

export {
  nvbugsIdSelector,
  synopsisSelector,
  otherProjectSelector,
  otherProjectListSelector,
  pageSelector,
  recProjectListSelector,
  recProjectListLoadingSelector,
  optionSelectedSelector,
  selectedProjectSelector
}


